export interface LearningPathIdApi {
  learningPathId: string;
}

export let isLearningPathIdResponseDTO = (
  variable: unknown
): variable is LearningPathIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "learningPathId" in variable &&
    typeof variable.learningPathId === "string"
  );
};
